import { initServiceWorker } from "./components/serviceWorker.js";
import Nav from "./components/nav.js";
import Slider from "./components/slider.js";
import Animate from "./components/animate.js";
import { Icons } from "./components/icons.js";
import Footer from "./components/footer.js";
import Projects from "./components/projects.js";
import Contact from "./components/contact.js";
import ScrollTop from "./components/scrollTop.js";
import CallFab from "./components/callFab.js";
import AboutSidebar from "./pages/about.js";
import { ProjectsTabs, ProjectGallery } from "./pages/projects.js";
import BlogFilter from "./pages/blogs.js";
import ReferencesCounters from "./pages/references.js";
import HomeBlogSlider from "./components/blog.js";
import CookieConsent from "./components/cookies.js";
import ServiceModal from "./components/serviceModal.js";
import Counter from "./components/counter.js";
import AboutImagesSlider from "./components/aboutImages.js";
import ProductInteractions from "./pages/products.js";
import QrMenuInteractions from "./pages/qrMenu.js";
import MarivaEffects from "./components/marivaEffects.js";
import ReferencesTicker from "./components/referencesTicker.js";
import ServiceDetailSwitch from "./components/serviceDetail.js";

initServiceWorker();

class Main {
  constructor() {
    this.init();
  }
  init() {
    new Slider();
    new Nav();
    new Footer();
    new Animate();
    new Icons();
    new Projects();
    new Contact();
    new ScrollTop();
    new CallFab();
    new AboutSidebar();
    new ProjectGallery();
    new ProjectsTabs();
    new BlogFilter();
    new ReferencesCounters();
    new HomeBlogSlider();
    new CookieConsent();
    new ServiceModal();
    new Counter();
    new AboutImagesSlider();
    new ProductInteractions();
    new QrMenuInteractions();
    new MarivaEffects();
    new ReferencesTicker();
    new ServiceDetailSwitch();
  }
}

export default Main;

document.addEventListener("DOMContentLoaded", () => {
  new Main();
});
